import { firebaseConfig } from '@/z-shared/config/firebase';
import { initializeApp } from 'firebase/app';
import { getMessaging } from 'firebase/messaging';

const { publicVapid, ...firebaseAppConfig } = firebaseConfig;

const app = initializeApp(firebaseAppConfig);
const messaging = (() => {
    try {
        return getMessaging(app);
    }
    catch {
        return { app };
    }
})();

export const firebase = {
    app, messaging, publicVapid,
};
